import { gql } from "@apollo/client";

const AvailableDevices = gql`
  query AvailableDevices {
    allDevices(condition: { isActive: true }, orderBy: DEVICE_NAME_ASC) {
      nodes {
        id
        latitudeField
        longitudeField
        altitudeField
        headingField
        orientedImageryType
        timeField
        timestampFormat
        deviceName
        dateTimeField
        dateField
        fileFormat
      }
    }
  }
`;

const hash = "f27849ac2683f24a38f5ed28c78e6302dba00db6a7031b1ab52c1e19bba4c857";
export { AvailableDevices, hash };
